import type { TaskSortMode } from '../../Components/TaskSortMenu/TaskSortMenu'
import type { Priority, Task } from '../../Models/Task'

const PRIORITY_RANK: Record<Priority, number> = { p1: 0, p2: 1, p3: 2, p4: 3 }

function priorityRank(p?: Priority): number {
  if (!p) return 99
  return PRIORITY_RANK[p] ?? 99
}

/** Incomplete tasks first, then completed. */
function incompleteFirst(a: Task, b: Task): number {
  return Number(!!a.completedAt) - Number(!!b.completedAt)
}

export function sortDashboardTasks(tasks: Task[], mode: TaskSortMode): Task[] {
  const arr = [...tasks]
  switch (mode) {
    case 'alphabetical':
      arr.sort((a, b) => {
        const c = incompleteFirst(a, b)
        if (c !== 0) return c
        return a.title.localeCompare(b.title, undefined, { sensitivity: 'base' })
      })
      break
    case 'created':
      arr.sort((a, b) => {
        const c = incompleteFirst(a, b)
        if (c !== 0) return c
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      })
      break
    case 'priority':
      arr.sort((a, b) => {
        const c = incompleteFirst(a, b)
        if (c !== 0) return c
        const d = priorityRank(a.priority) - priorityRank(b.priority)
        if (d !== 0) return d
        return a.title.localeCompare(b.title, undefined, { sensitivity: 'base' })
      })
      break
    default:
      break
  }
  return arr
}
